export const MODAL_NAMES = {
  RESET_PASSWORD_EXPLANATION: 'RESET_PASSWORD_EXPLANATION',
}

export const SIGNUP_MIN_AGE = 16

export const VALID_PASSWORD_REGEXP = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).+$/
export const PASSWORD_MIN_SIZE = 8
